/*
  A LINK WE SEND IS SHORT (the Product Owner, 2026-10-08/09; MTR #509; project doc 113).

  "如果是我…一连串超长的网址三四行，那要是我我根本就不会去点。" The video tour link was 521 characters on
  a supabase.co address nobody has heard of. A link we send is now go.stayoo.com/<seven letters>:
  twenty-one characters, on our own name, and the long address behind it never leaves our servers.

  SEVEN, NOT SIX. The code is the only thing standing between a stranger and a home's full tour, so
  it is drawn from the same 31 readable letters as an enquiry key, one longer: 31^7 ≈ 27.5 billion,
  and the server answers a guesser at the same rate it answers a renter.
*/
import { ALPHABET } from '../listing/enquiryLink.js'
import { RENTER_BASE } from '../shared/hosts.js'

const CODE_LENGTH = 7
const CODE = new RegExp(`^/([${ALPHABET}]{${CODE_LENGTH}})/?$`)
const TOUR = new RegExp(`^/tour/([${ALPHABET}]{${CODE_LENGTH}})/?$`)

/** A fresh code. Never Math.random: a code you can predict is a code you can guess. */
export function newShortCode(crypto = globalThis.crypto) {
  if (!crypto?.getRandomValues) throw new Error('this browser has no secure random source, so it cannot make a link')
  /* 248 is 31 × 8: every byte below it maps to a letter evenly; the rest are drawn again. */
  const ceiling = ALPHABET.length * Math.floor(256 / ALPHABET.length)
  let out = ''
  while (out.length < CODE_LENGTH) {
    for (const b of crypto.getRandomValues(new Uint8Array(CODE_LENGTH))) {
      if (b < ceiling && out.length < CODE_LENGTH) out += ALPHABET[b % ALPHABET.length]
    }
  }
  return out
}

/** The address a renter is sent: go.stayoo.com/<code>. */
export const shortLinkUrl = (code) => `${RENTER_BASE}/${code}`

/** The code in an address bar (`/k7m2qpx`), or null. */
export const shortCodeFromPath = (path) => (CODE.exec(String(path ?? '')) ?? [])[1] ?? null

/** Where a tour's short link lands: our own page, /tour/<code>. */
export const tourPagePath = (code) => `/tour/${code}`
export const tourCodeFromPath = (path) => (TOUR.exec(String(path ?? '')) ?? [])[1] ?? null
